"use client";

import { useEffect } from "react";

export default function ScrollUp() {
  useEffect(() => {
    // Braces matter: in recent browsers scrollTo() returns a Promise, and
    // React 19 throws if an effect returns anything other than a cleanup function.
    window.document.scrollingElement?.scrollTo(0, 0);
  }, []);

  return null;
}
